/** Small runtime hooks registry (replaces window._* callbacks). */
export const runtimeHooks = {
  notifyTicketArticle: null,
  macroTabAdd: null,
};
